/* Progressive enhancement: headings and article text do not depend on this file. */
(() => {
  if (window.hfArticleReaderLoaded) return;
  window.hfArticleReaderLoaded = true;
  const instances = new WeakMap();

  function init(article) {
    if (instances.has(article)) return;
    const layout = article.querySelector('[data-hf-article-reader]');
    const content = article.querySelector('[data-hf-article-content]');
    const aside = article.querySelector('[data-hf-article-toc]');
    if (!layout || !content || !aside) return;
    const headings = [...content.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
    if (headings.length < 2) return;
    const tables = [...content.querySelectorAll('table')].map(table => {
      const hint = document.createElement('p');
      hint.className = 'hf-article-table-hint';
      hint.textContent = content.dataset.hfTableScrollLabel || '';
      hint.hidden = true;
      table.before(hint);
      return { table, hint, tabindex: table.getAttribute('tabindex') };
    });
    const controller = new AbortController();
    const { signal } = controller;
    const panel = aside.querySelector('[data-hf-toc-panel]');
    const list = aside.querySelector('[data-hf-toc-list]');
    const media = window.matchMedia('(min-width:980px)');
    const used = new Set([...document.querySelectorAll('[id]')].map(el => el.id));
    const links = [];
    // Retain editorial IDs where possible; reserve each one before generating the next.
    headings.forEach((heading, index) => {
      const slug = heading.textContent.trim().toLowerCase().normalize('NFKC').replace(/[^\p{L}\p{N}\s-]/gu, '').replace(/[\s-]+/g, '-').replace(/^-|-$/g, '');
      const base = heading.id || `section-${slug || index + 1}`;
      let id = base;
      let suffix = 2;
      const keepExisting = heading.id && document.getElementById(heading.id) === heading;
      if (!keepExisting) while (used.has(id)) id = `${base}-${suffix++}`;
      used.add(id);
      heading.id = id;
      if (!heading.hasAttribute('tabindex')) heading.tabIndex = -1;
      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'is-subheading';
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(id)}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
      links.push(link);
      link.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!media.matches) panel.open = false;
        // Keep native fragment navigation/history; focus follows the reader, including keyboard users.
        history.pushState(null, '', `#${encodeURIComponent(id)}`);
        heading.focus({ preventScroll: true });
        window.scrollTo({ top: heading.getBoundingClientRect().top + window.scrollY - offset, behavior: 'instant' });
        setActive(index);
      }, { signal });
    });
    let active = -1;
    function setActive(index) {
      if (index === active) return;
      links.forEach((link, i) => i === index ? link.setAttribute('aria-current', 'location') : link.removeAttribute('aria-current'));
      active = index;
    }
    let offset = 140;
    const header = document.getElementById('shopify-section-hf-header');
    function measure() {
      offset = Math.ceil(header ? header.getBoundingClientRect().height : 100) + 24;
      article.style.setProperty('--hf-reader-offset', `${offset}px`);
      tables.forEach(({ table, hint, tabindex }) => {
        const scrollable = table.scrollWidth > table.clientWidth + 1;
        hint.hidden = !scrollable || !hint.textContent;
        if (scrollable) table.tabIndex = 0;
        else if (tabindex === null) table.removeAttribute('tabindex');
        else table.setAttribute('tabindex', tabindex);
      });
      update();
    }
    function update() {
      let index = 0;
      for (let i = 0; i < headings.length; i++) {
        if (headings[i].getBoundingClientRect().top <= offset + 8) index = i;
        else break;
      }
      setActive(index);
    }
    let frame;
    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = null; update(); });
    }
    function breakpoint() { panel.open = media.matches; measure(); }
    let observer;
    if (header && 'ResizeObserver' in window) { observer = new ResizeObserver(measure); observer.observe(header); }
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', measure, { passive: true, signal });
    media.addEventListener('change', breakpoint, { signal });
    aside.hidden = false;
    layout.classList.add('has-toc');
    breakpoint();
    if (location.hash) {
      let initialId;
      try { initialId = decodeURIComponent(location.hash.slice(1)); } catch { initialId = ''; }
      const initialHeading = headings.find(heading => heading.id === initialId);
      if (initialHeading) requestAnimationFrame(() => {
        window.scrollTo({ top: initialHeading.getBoundingClientRect().top + window.scrollY - offset, behavior: 'instant' });
        update();
      });
    }
    instances.set(article, () => { controller.abort(); observer?.disconnect(); if (frame) cancelAnimationFrame(frame); });
  }
  const scan = root => {
    if (root.matches?.('[data-hf-article]')) init(root);
    root.querySelectorAll('[data-hf-article]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-hf-article]').forEach(article => { instances.get(article)?.(); instances.delete(article); }));
})();
